// this is useful while we still need the backend,
// but can remove once we're using a real endpoint.

import _ from 'lodash';

// this comes in as a 'DOMStringMap', so this just makes it a regular ol' object
export const transformDataSet = dataset => {
  // wish I could do this in a cleaner way, but it seems to hate Object.assign,
  // the spread operator and _.values in Safari, so good ol' fashioned reduce
  // will have to do the trick.
  return _.reduce(
    dataset,
    (newObj, value, key) => {
      newObj[key] = value;
      return newObj;
    },
    {}
  );
};

export const transformServiceTypes = string => {
  // parses out service types from a className
  // comes in from the backend as:
  // service app-picker-item service-all service-files service-google
  // this parses it out to an object as:
  // { all: true, files: true, google: true}
  return _.flow(
    _.partialRight(_.replace, 'service app-picker-item', ''),
    _.trim,
    _.partialRight(_.split, 'service-'),
    _.compact,
    _.partialRight(_.map, service => [service.trim(), true]),
    _.fromPairs
  )(string);
};

export const selectFirst = (selector, node = document) =>
  node.querySelector(selector);

export const selectLast = (selector, node = document) =>
  _.toArray(node.querySelectorAll(selector)).pop();

export const selectAll = (selector, node = document) =>
  _.toArray(node.querySelectorAll(selector));

export const getChildren = node => _.toArray(_.get(node, 'children', []));

export const getClassName = node => _.get(node, 'className', '');

export const getText = node => _.get(node, 'textContent', '');

export const getPath = node => _.get(node, 'pathname', '');

export const getInnerText = node => _.get(node, 'innerText', '');

export const getStyle = node =>
  _.get(node, ['attributes', 'style', 'value'], '');

export const getHref = node => _.get(node, ['attributes', 'href', 'value'], '');

export const getVal = node => _.get(node, ['attributes', 'val', 'value'], '');

export const getDataSet = node => _.get(node, 'dataset', {});

export const parseInlineStyleURL = node =>
  !node
    ? ''
    : getStyle(node)
        .match(/\((.*?)\)/g)[0]
        .replace(/\(|\)|'/g, '');
